// @flow

import Avatar from '@atlaskit/avatar';

// https://atlaskit.atlassian.com/packages/core/avatar
const AvatarV2 = Avatar;
AvatarV2.displayName = 'AvatarV2';

export default AvatarV2;
